import React from 'react';

const ImageAttachment = ({ imageName, onRemove, isLoading = false }) => {
  return (
    <div className="image-attachment">
      {isLoading ? (
        <span>Loading image...</span>
      ) : (
        <span>{imageName}</span>
      )}
      <button onClick={onRemove} className="remove-image" disabled={isLoading}>
        ×
      </button>
    </div>
  );
};

export default ImageAttachment; 